const BaseUrl = "https://api.pillarshub.com";
export default BaseUrl